/* Sepetten kaldırmayı geri alma.

   Neden gerekli: adet 1'ken stepper'ın "−" düğmesi satırı siliyor (input
   `min="0"`). Bu davranış zaten vardı; artık çöp kutusu ikonuyla dürüstçe
   etiketlendiği için tek dokunuşla erişilebilir hale de geldi. 15-20 kalemlik
   bir sepette yanlışlıkla silme pahalı — etiketleme tek başına yetmez, geri
   dönüş yolu şart.

   Yakalama silmeden ÖNCE yapılıyor: tıklama anında satırın verisi (varyant,
   adet, properties) DOM'dan okunuyor, çünkü silme tamamlandığında o satır
   DOM'da yok. `properties` özellikle önemli — Car Coaster çiftinin ikinci
   deseni orada; atlanırsa geri alma çifti tekliye düşürürdü. */

const UNDO_MS = 6000;

class CartUndo extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this.textEl = this.querySelector('[data-undo-text]');
    this.btn = this.querySelector('[data-undo-btn]');
    this.pending = null;
    this.timer = null;

    /* Delegasyon document seviyesinde: satırlar her adet değişiminde yeniden
       çiziliyor, tek tek düğmeye bağlanmak her render'da kopardı. */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-line-remove]');
      if (!trigger) return;
      if (!trigger.closest('cart-drawer')) return; // sepet SAYFASI aynı satırı kullanıyor, orada şerit yok
      this.capture(trigger);
    });

    this.btn.addEventListener('click', () => this.restore());
  }

  capture(trigger) {
    let properties;
    try {
      properties = this.toHash(JSON.parse(trigger.dataset.undoProps || '{}'));
    } catch (error) {
      properties = undefined;
    }
    if (properties && Object.keys(properties).length === 0) properties = undefined;

    this.pending = {
      id: trigger.dataset.undoId,
      quantity: Number(trigger.dataset.undoQty) || 1,
      properties,
      label: trigger.dataset.undoLabel || '',
    };
    this.show();
  }

  /* Liquid'de `item.properties | json` bir OBJE değil, ÇİFT DİZİSİ üretiyor:
     `[["Pattern 2","C8P"]]`. Cart API bunu reddediyor —
     `400 expected Array to be a Hash: properties` (canlıda ölçüldü, iki form
     karşılaştırıldı). Diziyi objeye çeviriyoruz; obje gelirse olduğu gibi
     geçiyor, yani iki şekle de dayanıklı. */
  toHash(value) {
    if (!value) return undefined;
    if (Array.isArray(value)) {
      return value.reduce((acc, pair) => {
        if (Array.isArray(pair) && pair.length === 2) acc[pair[0]] = pair[1];
        return acc;
      }, {});
    }
    return value;
  }

  show() {
    if (!this.pending) return;
    const template = this.dataset.template || '__ITEM__';
    this.textEl.textContent = template.replace('__ITEM__', this.pending.label);

    /* Deck yüksekliği içeriğe göre değişiyor (indirim satırı açık/kapalı,
       ödeme ikonları vb. 170-260px). Şeridi deck'in tam üstüne oturtmak için
       ölçüp yazıyoruz — CSS'te sabit bir sayı tutmak er ya da geç kayardı. */
    const deck = document.querySelector('.aycan-cart-deck');
    if (deck) {
      const gap = 10;
      this.style.insetBlockEnd = `calc(${Math.round(deck.getBoundingClientRect().height) + gap}px + env(safe-area-inset-bottom, 0px))`;
    }

    this.hidden = false;
    /* Geçişin başlaması için tarayıcının `hidden` kalkışını bir kez yerleştirmesi
       gerekiyor. Bunu `requestAnimationFrame` ile yapıyordum ama rAF her ortamda
       tetiklenmiyor (arka plandaki/başsız görüntüleyicilerde askıya alınıyor) ve
       şerit `opacity:0`'da takılı kalıyordu. Zorunlu reflow senkron ve güvenilir. */
    void this.offsetWidth;
    this.classList.add('is-visible');

    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.dismiss(), UNDO_MS);
  }

  dismiss() {
    clearTimeout(this.timer);
    this.classList.remove('is-visible');
    this.pending = null;
    // görünürlüğü geçiş bitince kaldır, yoksa çıkış animasyonu görünmez
    setTimeout(() => {
      if (!this.classList.contains('is-visible')) this.hidden = true;
    }, 240);
  }

  restore() {
    if (!this.pending) return;
    const item = { id: this.pending.id, quantity: this.pending.quantity };
    if (this.pending.properties) item.properties = this.pending.properties;

    this.classList.add('is-busy');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then((response) => {
        if (!response.ok) {
          /* Sessizce yutma: geri alma başarısız olursa müşteri şeridin
             kaybolduğunu görür ve ürünün geri geldiğini SANIR. Önceki sürümde
             boş bir `catch` tam bu hatayı gizliyordu. */
          return response.json().then((error) => {
            throw new Error(error.description || error.message || 'cart/add failed');
          });
        }
        return response.json();
      })
      .then(() => this.refreshDrawer())
      .then(() => this.dismiss())
      .catch((error) => {
        console.error('[cart-undo] geri alma başarısız:', error.message);
        // Şerit açık kalsın ki müşteri tekrar deneyebilsin.
        this.classList.remove('is-busy');
      })
      .finally(() => {
        this.classList.remove('is-busy');
      });
  }

  /* Drawer'ın kendi render yolunu kullan: bölümü çekip aynı üç düğümü değiştir
     (cart-drawer.js `getSectionsToRender` ile birebir aynı hedefler). Sepet
     boşken tüm `#CartDrawer` değişiyor, o durumu da karşıla. */
  refreshDrawer() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(`${root}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const drawer = document.querySelector('cart-drawer');
        const wasEmpty = drawer.classList.contains('is-empty');
        drawer.classList.remove('is-empty');

        const targets = wasEmpty
          ? ['#CartDrawer']
          : ['.aycan-cart-chrome', '#CartDrawer-CartItems', '.aycan-cart-deck'];

        targets.forEach((selector) => {
          const fresh = parsed.querySelector(selector);
          const current = document.querySelector(selector);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });

        const bubble = new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section');
        const bubbleHost = document.querySelector('#cart-icon-bubble')?.closest('.shopify-section');
        if (bubble && bubbleHost) bubbleHost.innerHTML = bubble.innerHTML;
      });
  }
}

if (!customElements.get('cart-undo')) {
  customElements.define('cart-undo', CartUndo);
}
